import { AGGREGATE_NAMES, USER_RESOLVERS } from 'cpool-constants';
import { schemaUserResolverGetRepresentedUsers } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useRepresentedUsers = (userId: string | undefined) => {
    return useAggregateQuery({
        acl: { userId },
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.getRepresentedUsers,
        schema: schemaUserResolverGetRepresentedUsers,
        searchParams: {
            id: userId,
        },
    });
};
